import { render } from "./stickets.vue?vue&type=template&id=590a3a7c&scoped=true"
const script = {}

import "./stickets.vue?vue&type=style&index=0&id=590a3a7c&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590a3a7c"]])

export default __exports__